<template>
<div>
    <!-- <button class="btn btn-primary" v-on:click="getPDF('.pdf-page1')">Export to Pdf</button>
    <br/>
    <br/>
    <div class="pdf-page1 size-a4 well">
        <div>
            <div style="float:left">Partner : </div>
            <div style="float:right;margin:20px">STRICTLY CONFIDENTIAL</div>
        </div>

        <div class="potential" style="clear:both">Potential and Current value statement for Employee unit program as of december 31,2017</div>
        <table class="table">
            <thead>
                <tr>
                    <th style="border:none"></th>
                    <th class="th-head" style="border-bottom:none">Investment ID</th>
                    <th class="th-top" style="border-bottom:none">Units</th>
                    <th class="th-top" style="border-bottom:none">Vesting percentage</th>
                    <th class="th-head" style="border-bottom:none">Previous unit distributions</th>
                    <th class="th-top" style="border-bottom:none">Projected unrealized value (undiscounted)</th>
                    <th class="th-top" style="border-bottom:none">Total potential pre-tax value</th>
                    <th class="th-top" style="border-right:1px solid">Total Potential Pre-Tax Value Percentage Change Since Prior Statement</th>
                    <th class="th-top" style="border-bottom:none">Current values (discounted)</th>
                    <th class="th-top" style="border-bottom:none">Total current pre-tax value</th>
                    <th class="th-top" style="border-right:1px solid">Total current pre-tax value percentage change since prior statement</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style="white-space: nowrap;border:none">Fund Investments (not cross-collateralized)</td>
                    <td class="th-head">$1.00</td>
                    <td class="th-top">$1.00</td>
                    <td class="th-top">$0.00</td>
                    <td class="th-head">$0.00</td>
                    <td class="th-top">$0.00</td>
                    <td class="th-top">$1.00</td>
                    <td class="th-top" style="border-right:1px solid">$0.00</td>
                    <td class="th-top">$0.00</td>
                    <td class="th-top">$0.00</td>
                    <td class="th-top" style="border-right:1px solid">$0.00</td>
                </tr>
              
            </tbody>
        </table>
        <br/>
        <p> [1] Distributions made after the "as of" Statement date, but prior to issuance of this Statement, are not reflected above. Such distributions, if any, will be reflected in a subsequent statement. Distributions reflected include both unit distributions and slice distributions, if any.
            <br/>    [2]	Projected Unrealized Values are based on anticipated cash flows projected by Portfolio Management over time and from time to time. Projected Unrealized Values do not reflect discounts for the time value of money, illiquidity, minority interests, partnership or personnel risks, the uncertainty of achieving targeted or projected returns, the uncertainty of fundraising, or for any other factors that might impact value. There is no assurance that targeted or projected performance levels will be achieved. The values of the units in Combined Investments do not reflect any discount to take account of the cross-collateralization of these Combined Investments (however, see footnote [4] below regarding Peter Cooper Village/Stuyvesant Town). Projected Unrealized Values will be zero if net returns for the above investments are not sufficient to cover the cost of borrowings incurred to finance such unit investments.
            <br/>    [3]	The current values are based on estimated current values. These estimated current values do not take into account projected defeasance costs related to current debt or discounts for illiquidity, minority interests, partnership or personnel risks, the uncertainty of achieving targeted or projected returns, the uncertainty of fundraising, or for any other factors that might impact value. There is no assurance that actual sales will equal estimated current values.
            <br/>    [4]	Except as noted below, the loss on Peter Cooper Village/Stuyvesant Town (PCV/ST) is shared by all of the investments in the Combined Investments (cross-collateralized) pool, and therefore reduces the values of the other investments in the pool. The projected values shown for the investments listed under Combined Investments above have been reduced accordingly to reflect their respective shares of the PCV/ST loss. This $1.00s not apply to Combined Investments that were made after the PCV/ST loss was incurred, which follow PCV/ST on the list of Combined Investments above.
            <br/>    [5]	72% of Fund VIII is cross-collateralized and 28% is not cross-collateralized.
            <br/>    [6]	Values reflected take into consideration Tishman Speyer Equity Participation Partners, L.P.'s investment even though Tishman Speyer Equity Participation Partners, L.P. did not make this investment until after 12/31/17.
        </p>
    </div>
    <div class="EUMGridConfig1" style="display:none">
        <BaseGrid :config="EUMGridConfig" :data="BaseModelTransferData"></BaseGrid>
        <br/>
        <p> [1] Distributions made after the "as of" Statement date, but prior to issuance of this Statement, are not reflected above. Such distributions, if any, will be reflected in a subsequent statement. Distributions reflected include both unit distributions and slice distributions, if any.
            <br/>    [2]	Projected Unrealized Values are based on anticipated cash flows projected by Portfolio Management over time and from time to time. Projected Unrealized Values do not reflect discounts for the time value of money, illiquidity, minority interests, partnership or personnel risks, the uncertainty of achieving targeted or projected returns, the uncertainty of fundraising, or for any other factors that might impact value. There is no assurance that targeted or projected performance levels will be achieved. The values of the units in Combined Investments do not reflect any discount to take account of the cross-collateralization of these Combined Investments (however, see footnote [4] below regarding Peter Cooper Village/Stuyvesant Town). Projected Unrealized Values will be zero if net returns for the above investments are not sufficient to cover the cost of borrowings incurred to finance such unit investments.
            <br/>    [3]	The current values are based on estimated current values. These estimated current values do not take into account projected defeasance costs related to current debt or discounts for illiquidity, minority interests, partnership or personnel risks, the uncertainty of achieving targeted or projected returns, the uncertainty of fundraising, or for any other factors that might impact value. There is no assurance that actual sales will equal estimated current values.
            <br/>    [4]	Except as noted below, the loss on Peter Cooper Village/Stuyvesant Town (PCV/ST) is shared by all of the investments in the Combined Investments (cross-collateralized) pool, and therefore reduces the values of the other investments in the pool. The projected values shown for the investments listed under Combined Investments above have been reduced accordingly to reflect their respective shares of the PCV/ST loss. This $1.00s not apply to Combined Investments that were made after the PCV/ST loss was incurred, which follow PCV/ST on the list of Combined Investments above.
            <br/>    [5]	72% of Fund VIII is cross-collateralized and 28% is not cross-collateralized.
            <br/>    [6]	Values reflected take into consideration Tishman Speyer Equity Participation Partners, L.P.'s investment even though Tishman Speyer Equity Participation Partners, L.P. did not make this investment until after 12/31/17.
        </p>
    </div> -->
    <div>
        <iframe class="visual-sandbox" sandbox="allow-scripts" name="visual-sandbox" width="532" height="148" src="https://app.powerbi.com/13.0.8730.136/cvSandboxMinimal.html?plugin=Timeline1447991079100&amp;locale=en-US&amp;instanceId=7ca5016c-0c8a-cdfd-8bb0-68bd3e4afb5d" style="width: 532px; height: 132px;"></iframe> 
    </div>
</div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import BaseGrid from "@/components/base/BaseGrid.vue";
import {
    EUMGridConfig
} from "./TestPdf.js";
import {
    mapGetters
} from 'vuex';

export default {
    components: {
        BaseGrid
    },
    mounted() {
        this.BaseModelTransferData = this.withFilter(this.EUMGridConfig.list);
        $(document).ready(function () {

        })
        $.fn.superScript = function () {
            var chars = '+−=()0123456789AaÆᴂɐɑɒBbcɕDdðEeƎəɛɜɜfGgɡɣhHɦIiɪɨᵻɩjJʝɟKklLʟᶅɭMmɱNnɴɲɳŋOoɔᴖᴗɵȢPpɸrRɹɻʁsʂʃTtƫUuᴜᴝʉɥɯɰʊvVʋʌwWxyzʐʑʒꝯᴥβγδθφχнნʕⵡ',
                sup = '⁺⁻⁼⁽⁾⁰¹²³⁴⁵⁶⁷⁸⁹ᴬᵃᴭᵆᵄᵅᶛᴮᵇᶜᶝᴰᵈᶞᴱᵉᴲᵊᵋᶟᵌᶠᴳᵍᶢˠʰᴴʱᴵⁱᶦᶤᶧᶥʲᴶᶨᶡᴷᵏˡᴸᶫᶪᶩᴹᵐᶬᴺⁿᶰᶮᶯᵑᴼᵒᵓᵔᵕᶱᴽᴾᵖᶲʳᴿʴʵʶˢᶳᶴᵀᵗᶵᵁᵘᶸᵙᶶᶣᵚᶭᶷᵛⱽᶹᶺʷᵂˣʸᶻᶼᶽᶾꝰᵜᵝᵞᵟᶿᵠᵡᵸჼˤⵯ';

            return this.each(function () {
                this.value = this.value.replace(/<sup[^>]*>(.*?)<\/sup>/g, function (x) {
                    var str = '',
                        txt = $.trim($(x).unwrap().text());

                    for (var i = 0; i < txt.length; i++) {
                        var n = chars.indexOf(txt[i]);
                        str += (n != -1 ? sup[n] : txt[i]);
                    }
                    return str;
                });
            });
        }

    },
    computed: {
        ...mapGetters("getModule", ["withFilter"])
    },
    data: function () {
        return {
            BaseModelTransferData: [],
            EUMGridConfig: EUMGridConfig
        }
    },
    methods: {
        document() {

        },
        getPDF(selector, output) {
            //document.getElementById("outputId").innerHTML = $(selector).html()
            kendo.drawing.drawDOM($(selector)).then(function (group) {
                kendo.drawing.pdf.saveAs(group, "EUMPartner.pdf");
            });
            //$(output).css("display", "none")
        },
    }
}
</script>

<style scoped>
.pdf-page1 {
    font-family: "DejaVu Sans", "Arial", sans-serif;
}

table>tbody:nth-child(2n+1)>tr,
table>tbody:nth-child(2n+1)>tr {
    background-color: #dee2e6;
}

table td {
    padding: 0 10px !important;
}

table th {
    padding: 10px 5px !important;
}

tr{
    border: 0 !important;
}

th.th-head {
    border: 1px solid !important;
}

th.th-top {
    border-top: 1px solid !important;
    border-bottom: 1px solid !important;
}

.potential {
    text-align: center;
    margin-bottom: 20px;
    text-transform: uppercase;
}

.pdf-page1 {
    position: relative;
    margin: 30px;
    padding: 0.4in 0.3in;
    color: #333;
    background-color: #fff;
    /* box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.3); */
    /* box-sizing: border-box; */
    margin-left: 30px;
    margin-top: 30px;
    margin-bottom: 30px;
}

h6 {
    text-align: center !important;
}

table {
    width: 100%;
    height: 100%;
}

td {
    height: 20px;
}

@media print {
    .btn-primary {
        display: none !important;
    }
}
</style>
